// Cookie helper functions
function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/;SameSite=Lax';
}

function getCookie(name) {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

document.addEventListener('DOMContentLoaded', function () {
  const contactPopup = document.getElementById('contact-pop-up');

  if (!contactPopup) {
    return;
  }

  const toggleButton = document.getElementById('contact-pop-up-toggle');
  const content = document.getElementById('contact-pop-up-content');
  const mainToggle = document.getElementById('contact-toggle');
  const offerteToggle = document.getElementById('offerte-toggle');
  const showroomToggle = document.getElementById('showroom-toggle');
  const offerteModal = document.getElementById('contact-pop-up-offerte-modal');
  const showroomModal = document.getElementById('contact-pop-up-showroom-modal');
  const isProductPage = contactPopup.dataset.pageType === 'product';

  let scrollOpened = false;
  let productOfferModalOpen = false;
  let lastTrigger = null;

  function setMainOpen(isOpen) {
    contactPopup.classList.toggle('is-open', isOpen);

    if (content) {
      content.hidden = !isOpen;
      content.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }

    if (mainToggle) {
      mainToggle.checked = isOpen;
    }

    if (toggleButton) {
      toggleButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      toggleButton.setAttribute('aria-label', isOpen ? 'Contactopties sluiten' : 'Contactopties openen');
    }
  }

  function setModalOpen(modalName) {
    const isOfferteOpen = modalName === 'offerte';
    const isShowroomOpen = modalName === 'showroom';

    if (offerteToggle) {
      offerteToggle.checked = isOfferteOpen;
    }

    if (showroomToggle) {
      showroomToggle.checked = isShowroomOpen;
    }

    if (offerteModal) {
      offerteModal.hidden = !isOfferteOpen;
      offerteModal.classList.toggle('is-open', isOfferteOpen);
    }

    if (showroomModal) {
      showroomModal.hidden = !isShowroomOpen;
      showroomModal.classList.toggle('is-open', isShowroomOpen);
    }

    if (isOfferteOpen || isShowroomOpen) {
      setMainOpen(true);
    }
  }

  function closeModals() {
    setModalOpen(null);

    if (isProductPage && !productOfferModalOpen) {
      setMainOpen(false);
    }
  }

  function closeMain() {
    setModalOpen(null);
    setMainOpen(false);

    if (scrollOpened) {
      setCookie('contactPopupDismissed', 'true', 30);
    }
  }

  function openModal(modalName, trigger) {
    if (modalName !== 'offerte' && modalName !== 'showroom') {
      return;
    }

    lastTrigger = trigger || document.activeElement;
    setModalOpen(modalName);

    const modal = modalName === 'offerte' ? offerteModal : showroomModal;
    const closeButton = modal?.querySelector('[data-contact-popup-close]');

    window.requestAnimationFrame(function () {
      closeButton?.focus();
    });
  }

  if (toggleButton) {
    toggleButton.addEventListener('click', function () {
      if (contactPopup.classList.contains('is-open')) {
        closeMain();
      } else {
        lastTrigger = toggleButton;
        setMainOpen(true);
      }
    });
  }

  document.addEventListener('click', function (event) {
    const openTrigger = event.target.closest('[data-contact-popup-open]');
    const closeTrigger = event.target.closest('[data-contact-popup-close]');

    if (openTrigger) {
      event.preventDefault();
      openModal(openTrigger.dataset.contactPopupOpen, openTrigger);
      return;
    }

    if (closeTrigger) {
      event.preventDefault();
      closeModals();
      lastTrigger?.focus();
    }
  });

  document.addEventListener('change', function (event) {
    if (event.target === offerteToggle) {
      if (offerteToggle.checked) {
        openModal('offerte', document.activeElement);
      } else {
        closeModals();
      }
    }

    if (event.target === showroomToggle) {
      if (showroomToggle.checked) {
        openModal('showroom', document.activeElement);
      } else {
        closeModals();
      }
    }
  });

  document.querySelectorAll('#toggleShowroomForm').forEach(function (toggle) {
    toggle.addEventListener('click', function (event) {
      event.preventDefault();

      if (showroomToggle?.checked) {
        closeModals();
      } else {
        openModal('showroom', toggle);
      }
    });
  });

  window.addEventListener('product-offer-modal', function (event) {
    productOfferModalOpen = Boolean(event.detail && event.detail.open);

    if (productOfferModalOpen) {
      setMainOpen(true);
    } else if (!offerteToggle?.checked && !showroomToggle?.checked) {
      setMainOpen(false);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') {
      return;
    }

    if (offerteToggle?.checked || showroomToggle?.checked) {
      closeModals();
      lastTrigger?.focus();
    } else if (contactPopup.classList.contains('is-open')) {
      closeMain();
      toggleButton?.focus();
    }
  });

  if (!isProductPage) {
    window.addEventListener(
      'scroll',
      function () {
        const dismissed = getCookie('contactPopupDismissed');

        if (!scrollOpened && !dismissed && window.scrollY >= 250) {
          scrollOpened = true;
          setMainOpen(true);
        }
      },
      { passive: true }
    );
  }
});
